import React, { Component, createRef } from 'react';
import FJSlider from '../slider/FJSlider';
import FJKeymap from '../../../../util/FJKeymap';
import Style from './FJController.module.less';
import FJUtil from '../../../../util/FJUtil';
import FJPlayIcon from '../../../../assets/svg/play.svg?react';
import FJStopIcon from '../../../../assets/svg/stop.svg?react';
import FJFullScreenIcon from '../../../../assets/svg/full-screen.svg?react';
import FJFullScreenExitIcon from '../../../../assets/svg/full-screen-exit.svg?react';
import FJPlayBtn from '../FJPlayBtn/FJPlayBtn';
import FJPreviewVolumeContainer from '../FJVolumeController/FJPreviewVolumeContainer.jsx';
import classNames from 'classnames';

class FJController extends Component {
    constructor(props) {
        super(props);
        this._isPlayingStateBeforeSeek = false;
        this._boxRef = createRef();
        this._volumeRef = createRef();
        this.state = {
            isPlaying: false,
            progress: 0,
        };
    }

    componentDidMount() {
        const { isKeySpace = false, disabled, scope = 'modal' } = this.props;
        if (isKeySpace && !disabled) {
            this.unKeyMap1 = FJKeymap.keymap(32, this.switchPlay, { scope });
        }
    }

    componentDidUpdate(prevProps) {
        const { isKeySpace = false, disabled, scope = 'modal' } = this.props;
        if (isKeySpace && !disabled) {
            this.unKeyMap1 && this.unKeyMap1();
            this.unKeyMap1 = FJKeymap.keymap(32, this.switchPlay, { scope });
        }
    }

    componentWillUnmount() {
        this.unKeyMap1 && this.unKeyMap1();
    }

    /**
     * @description 空格控制播放暂停
     */
    switchPlay = e => {
        if (this.props.disabled) return;
        e?.stopPropagation();
        e?.preventDefault();
        if (this.isPlaying()) {
            this._pause();
        } else {
            this._play();
        }
        this.hideVolume();
    };

    getVolume = () => {
        return this._volumeRef.current.getVolume();
    };
    isPlaying = () => {
        return this.state.isPlaying;
    };
    updateProgress = progress => {
        if (this.props.disabled) return;
        this.setState({ progress: progress });
    };
    getProgress = () => {
        return this.state.progress;
    };
    reset = () => {
        if (this.props.disabled) return;
        this.setState({ isPlaying: false, progress: 0 });
        this.hideVolume();
    };

    hideVolume = () => {
        if (this._volumeRef?.current) {
            this._volumeRef?.current?.hideVolume();
        }
    };
    resetVolume = () => {
        if (this._volumeRef?.current) {
            this._volumeRef?.current.resetVolume();
        }
    };

    triggerController = (e, toggle) => {
        if (e) {
            e.stopPropagation();
        }
        this.hideVolume();
        if (typeof toggle === 'undefined') {
            if (this.state.isPlaying) {
                this._pause();
            } else {
                this._play();
            }
        } else {
            if (toggle) {
                this._play();
            } else {
                this._pause();
            }
        }
    };
    changePlayState = play => {
        this.setState({ isPlaying: play });
    };
    _play = () => {
        let result = this.props.play();
        if (false !== result) {
            this.setState({ isPlaying: true });
        }
    };
    _pause = () => {
        this.setState({ isPlaying: false });
        this.props.pause();
    };

    _setVideoBegin = () => {
        this.props.setVideoBegin && this.props.setVideoBegin();
    };
    _onBeforeChange = (value, progress) => {
        this._isPlayingStateBeforeSeek = this.state.isPlaying;
        if (this.state.isPlaying) {
            this._pause();
        }
        this.props.dataChange(progress);
        this.setState({ progress: progress });
        this.hideVolume();
    };
    _onChange = (value, progress) => {
        if (this.props.disabled) return;
        this.props.dataChange(progress);
        this.setState({ progress: progress });
    };
    _onAfterChange = (value, progress) => {
        if (this.props.disabled) return;
        this.props.dataChange(progress);
        if (this._isPlayingStateBeforeSeek) {
            if (progress >= 1) {
                this._pause();
                this._setVideoBegin();
            } else {
                this._play();
            }
        } else {
            this._pause();
        }
    };

    render() {
        let progress = this.state.progress;
        let curTime = progress * this.props.duration || 0;
        let currentTime = FJUtil.formatTime(curTime);
        let totalTime = FJUtil.formatTime(this.props.duration);
        const {
            isShowPlayBtn = true,
            isShowFullScreen,
            fullScreenClick,
            isFullScreen,
            previewVolumeChange,
            isShowVolume = false,
            disabled = false,
        } = this.props;
        return (
            <>
                <div
                    ref={this._boxRef}
                    className={classNames(Style.container, { [Style.disabled]: disabled })}
                    onClick={e => e.stopPropagation()}
                >
                    <div className={Style.operate}>
                        <div className={Style.left}>
                            <div onClick={e => this.triggerController(e)} className={Style.control}>
                                <div style={{ display: this.state.isPlaying ? 'block' : 'none' }}>
                                    <FJStopIcon />
                                </div>
                                <div style={{ display: !this.state.isPlaying ? 'block' : 'none' }}>
                                    <FJPlayIcon />
                                </div>
                            </div>
                            {isShowVolume && (
                                <div className={Style.volume}>
                                    <FJPreviewVolumeContainer
                                        ref={this._volumeRef}
                                        previewVolumeChang={previewVolumeChange}
                                    />
                                </div>
                            )}
                        </div>
                        <div className={Style.center}>
                            <div className={Style.progress}>
                                <FJSlider
                                    sliderClass={Style.slider}
                                    railClass={Style.rail}
                                    handleClass={Style.handle}
                                    trackClass={Style.track}
                                    progress={progress}
                                    onBeforeChange={this._onBeforeChange}
                                    onChange={this._onChange}
                                    onAfterChange={this._onAfterChange}
                                />
                            </div>
                        </div>
                        <div className={Style.right}>
                            <span className={Style.time}>{currentTime + ' / ' + totalTime}</span>
                            {isShowFullScreen && (
                                <div className={Style.screen} onClick={fullScreenClick}>
                                    {isFullScreen ? <FJFullScreenExitIcon /> : <FJFullScreenIcon />}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {!this.state.isPlaying && isShowPlayBtn && <FJPlayBtn onClick={e => this.triggerController(e)} />}
            </>
        );
    }
}

export default FJController;
